// import React, { useState, useRef, useEffect } from 'react';
// import { apiCall } from '@/api/apiCall';
// import { toast } from 'sonner';
// import { useApiQueue } from '@/hooks/useApiQueue';
// import AlBahaContract from '@/assets/img/AlBahaContract.png';
// import CarPark from '@/assets/img/TaifContract-carPark.png';
// import OnStreet from '@/assets/img/TaifContract-onStreet.png';
// import Enforcement from '@/assets/img/TaifContract-Enforcement.png';
// import { AssetsPanel } from '../../components/shared/AssetsPanel';
// import LoadingComponent from '@/components/common/LoadingComponent';
// import { API_CALL_TIME } from '@/constants/constant';

// // ═══════════════════════════════════════════════════════════════════════
// // HELPERS
// // ═══════════════════════════════════════════════════════════════════════
// const groupsToFlat = (groups = []) => {
//   const result = [];
//   groups.forEach(g => {
//     result.push({ name: g.group_name || '', isCategory: true, subCount: '', totalCount: String(g.group_total_qty ?? '-') });
//     (g.items || []).forEach(item => {
//       result.push({ name: item.item_name || '', isCategory: false, subCount: String(item.qty ?? '-'), totalCount: '' });
//     });
//   });
//   return result;
// };

// const flatToGroups = (flat) => {
//   const groups = [];
//   let cur = null;
//   flat.forEach(a => {
//     if (a.isCategory) {
//       if (cur) groups.push(cur);
//       cur = { group_name: a.name, group_total_qty: a.totalCount || '', items: [] };
//     } else if (cur) {
//       cur.items.push({ item_name: a.name, qty: a.subCount || '' });
//     }
//   });
//   if (cur) groups.push(cur);
//   return groups;
// };

// // ═══════════════════════════════════════════════════════════════════════
// // ASSET GROUPS HELPER
// // ═══════════════════════════════════════════════════════════════════════
// function makeAssetGroups(o = {}) {
//   return [
//     { group_name: 'Ticket Dispenser',    group_total_qty: o.ticketDispenser ?? '-', items: [{ item_name: 'DIP G100', qty: o.dipG100 ?? '-' }, { item_name: 'G100 64 Bit', qty: o.g10064 ?? '-' }, { item_name: 'G100 32 Bit', qty: o.g10032 ?? '-' }] },
//     { group_name: 'Ticket Verifier',     group_total_qty: o.ticketVerifier  ?? '-', items: [{ item_name: 'EV DIP G100', qty: o.evDipG100 ?? '-' }, { item_name: 'EV G100 64 Bit', qty: o.evG10064 ?? '-' }, { item_name: 'EV G100 32 Bit', qty: o.evG10032 ?? '-' }] },
//     { group_name: "APM's",               group_total_qty: o.apms            ?? '-', items: [{ item_name: 'APM ETS-70', qty: o.apmEts70 ?? '-' }, { item_name: 'APM ETS-100', qty: o.apmEts100 ?? '-' }] },
//     { group_name: 'PIN Pad',             group_total_qty: o.pinPad          ?? '-', items: [{ item_name: 'IUP250', qty: o.iup250 ?? '-' }] },
//     { group_name: 'Card Reader',         group_total_qty: o.cardReader      ?? '-', items: [{ item_name: 'IUR250', qty: o.iur250 ?? '-' }] },
//     { group_name: 'B-Contactless',       group_total_qty: o.bContactless    ?? '-', items: [{ item_name: 'IUC150', qty: o.bContactlessItem ?? '-' }] },
//     { group_name: 'RFID Reader',         group_total_qty: o.rfidReader      ?? '-', items: [] },
//     { group_name: 'IP Barrier',          group_total_qty: o.ipBarrier       ?? '-', items: [] },
//     { group_name: 'ANPR CAMERA',         group_total_qty: o.anprCamera      ?? '-', items: [{ item_name: 'ARH', qty: o.arh ?? '-' }, { item_name: 'Luminera', qty: o.luminera ?? '-' }] },
//     { group_name: 'Sliding Gate',        group_total_qty: o.slidingGate     ?? '-', items: [{ item_name: 'RIGHT', qty: o.right ?? '-' }, { item_name: 'LEFT', qty: o.left ?? '-' }] },
//     { group_name: "PND's",               group_total_qty: o.pnds            ?? '-', items: [{ item_name: 'TPAL- BNA Large', qty: o.tpalBna ?? '-' }, { item_name: 'T-PAL TX', qty: o.tpalTx ?? '-' }, { item_name: 'T-PAL V2', qty: o.tpalV2 ?? '-' }] },
//     { group_name: 'Pound Cahier Device', group_total_qty: o.poundCahier     ?? '-', items: [{ item_name: 'CN-50', qty: o.cn50 ?? '-' }] },
//     { group_name: 'Driver Device',       group_total_qty: o.driverDevice    ?? '-', items: [{ item_name: 'CN-51', qty: o.cn51 ?? '-' }] },
//     { group_name: 'Enf Device',          group_total_qty: o.enfDevice       ?? '-', items: [{ item_name: 'Oukitel WP2', qty: o.oukitel ?? '-' }, { item_name: 'Doogee V10', qty: o.doogee ?? '-' }] },
//     { group_name: 'Validation',          group_total_qty: o.validation      ?? '-', items: [{ item_name: 'Lenova Tablet', qty: o.lenovaTablet ?? '-' }] },
//     { group_name: 'Printer',             group_total_qty: o.printer         ?? '-', items: [{ item_name: 'PR-3', qty: o.pr3 ?? '-' }, { item_name: 'SEWOO', qty: o.sewoo ?? '-' }, { item_name: 'BIXOLON', qty: o.bixolon ?? '-' }] },
//     { group_name: 'Tow Truck',           group_total_qty: o.towTruck        ?? '-', items: [] },
//     { group_name: 'Clamp Vehicle',       group_total_qty: o.clampVehicle    ?? '-', items: [] },
//     { group_name: 'Support Vehicle',     group_total_qty: o.supportVehicle  ?? '-', items: [] },
//   ];
// }

// // ═══════════════════════════════════════════════════════════════════════
// // CONFIG
// // ═══════════════════════════════════════════════════════════════════════
// const ALBAHA_PROFILE_CONFIG = {

//   // ── Al Baha On-Street Profile ───────────────────────────────────────
//   albaha_on_street_profile: {
//     profileKey:       'albaha_on_street_profile',
//     violationKey:     'albaha_on_street_violations',
//     assetsKey:        'albaha_on_street_assets',
//     pageType:         'on_street',

//     profileFallback: {
//       table_key: 'albaha_on_street_profile',
//       title: 'Al Baha On Street - Profile',
//       data: {
//         total_bays:        { label: 'Total On-Street Parking Bays', value: '1,721' },
//         contract_term:     { value: '23 years' },
//         contract_period:   { start_date: '12.07.2021', end_date: '12.10.2045' },
//         operational_hours: { value: '15 Hours', from: '08:00', to: '23:00' },
//         rate_per_hour:     { value: 'SAR 03 + VAT 15%' },
//       },
//     },

//     violationFallback: {
//       table_key: 'albaha_on_street_violations',
//       title: 'Al Baha On Street Violation Summary (Excluding Vat)',
//       data: {
//         rows: [
//           { city_code: 'BAHA', violation_code: '1',  violation_name: 'THE USE OF PARKING SPACE WITHOUT PAYING THE PARKING FEE',    isLong:true,                 ticket_charges: '200',           tow_charges: '250',      clamp_charges: '0' },
//           { city_code: 'BAHA', violation_code: '2',  violation_name: 'THE EXPIRY OF THE PAID PARKING PERIOD WITHOUT VACATING THE PARKING SPACE',      ticket_charges: '100',           tow_charges: '-',        clamp_charges: '0' },
//           { city_code: 'BAHA', violation_code: '3',  violation_name: 'EXCEEDING THE MAXIMUM TIME ALLOWED FOR THE PARKING SPACE',                      ticket_charges: '100',           tow_charges: '250',      clamp_charges: '0' },
//           { city_code: 'BAHA', violation_code: '4',  violation_name: 'PARKING CONTRARILY WITHIN THE PAID PARKING SPACE',                              ticket_charges: '300',           tow_charges: '250',      clamp_charges: '0' },
//           { city_code: 'BAHA', violation_code: '5',  violation_name: 'PARKING IN A RESERVED PARKING SPACE',                                           ticket_charges: '300',           tow_charges: '250',      clamp_charges: '0' },
//           { city_code: 'BAHA', violation_code: '6',  violation_name: 'PARKING IN A RESTRICTED SPACE',                                                 ticket_charges: '300',           tow_charges: '250',      clamp_charges: '0' },
//           { city_code: 'BAHA', violation_code: '7',  violation_name: 'PLACING BARRIERS, OBSTRUCTIONS, FORGERY, OR CLOSING A PARKING SPACE WITHOUT A PERMIT', ticket_charges: '400',  tow_charges: '250',      clamp_charges: '0' },
//           { city_code: 'BAHA', violation_code: '8',  violation_name: 'PARKING IN THE EMERGENCY DESIGNATED AREAS',                                     ticket_charges: '900',           tow_charges: '250',      clamp_charges: '0' },
//           { city_code: 'BAHA', violation_code: '9',  violation_name: 'PARKING AT THE ENTRANCES AND EXITS OF BUILDINGS',                               ticket_charges: '500',           tow_charges: '250',      clamp_charges: '0' },
//           { city_code: 'BAHA', violation_code: '10', violation_name: 'TOW CHARGES (Light & Heavy Vehicle)',                                            ticket_charges: '0',             tow_charges: '250/1250', clamp_charges: '0' },
//           { city_code: 'BAHA', violation_code: '11', violation_name: 'STORAGE CHARGES (Light & Heavy Vehicle)',                                        ticket_charges: '20/50 per day', tow_charges: '0',        clamp_charges: '0' },
//         ],
//       },
//     },

//     assetsFallback: {
//       table_key: 'albaha_on_street_assets',
//       title: 'Al Baha On-street',
//       data: {
//         groups: makeAssetGroups({
//           ticketDispenser: '-', ticketVerifier: '1', evG10064: '1',
//           apms: '-', pinPad: '-', cardReader: '-', iur250: '-',
//           bContactless: '-', rfidReader: '4', ipBarrier: '-',
//           anprCamera: '-', slidingGate: '3', right: '2', left: '1',
//           pnds: '95', tpalTx: '63', tpalV2: '32',
//           poundCahier: '-', driverDevice: '-',
//           enfDevice: '19', oukitel: '-', doogee: '19',
//           validation: '-', printer: '25', pr3: '-', sewoo: '-', bixolon: '25',
//           towTruck: '6', clampVehicle: '1', supportVehicle: '1',
//         }),
//       },
//     },
//   },

//   // ── Al Baha Off-Street Profile ──────────────────────────────────────
//   albaha_off_street_profile: {
//     profileKey:  'albaha_off_street_profile',
//     assetsKey:   'albaha_off_street_assets',
//     pageType:    'off_street',

//     profileFallback: {
//       table_key: 'albaha_off_street_profile',
//       title: 'Al Baha Off-Street Profile',
//       data: {
//         total_bays:        { label: 'Total Off Street Car Park Bays', value: '........' },
//         contract_term:     { value: '23 years' },
//         contract_period:   { start_date: '12.07.2021', end_date: '12.10.2045' },
//         operational_hours: { value: '........', from: '.......', to: '....... ' },
//         rate_per_hour:     { value: '........' },
//       },
//     },

//     assetsFallback: {
//       table_key: 'albaha_off_street_assets',
//       title: 'Al Baha Off-street',
//       data: {
//         groups: makeAssetGroups({
//           ticketDispenser: '-', ticketVerifier: '-',
//           apms: '-', pinPad: '-', cardReader: '-',
//           bContactless: '-', rfidReader: '-', ipBarrier: '-',
//           anprCamera: '-', slidingGate: '-', pnds: '-',
//           poundCahier: '-', driverDevice: '-', enfDevice: '-',
//           validation: '-', printer: '-', towTruck: '-',
//           clampVehicle: '-', supportVehicle: '-',
//         }),
//       },
//     },
//   },
// };

// // ═══════════════════════════════════════════════════════════════════════
// // MAIN COMPONENT
// // ═══════════════════════════════════════════════════════════════════════
// const AlBahaProfile = ({ page, year = '', monthNumber = '', contract = '' }) => {
//   const cfg = ALBAHA_PROFILE_CONFIG[page?.type];
//   if (!cfg) return null;

//   const hasFetchedRef = useRef(false);
//   const saveRef = useRef(null);
//   const [isSaving, setIsSaving] = useState(false);
//   const [profileData, setProfileData] = useState(null);
//   const [assetsData, setAssetsData] = useState(null);
//   const [violationData, setViolationData] = useState(null);
  
//   const { enqueue } = useApiQueue();

//   // Refs for profile inputs
//   const totalBaysRef = useRef(null);
//   const contractTermRef = useRef(null);
//   const contractStartDateRef = useRef(null);
//   const contractEndDateRef = useRef(null);
//   const operationalHoursValueRef = useRef(null);
//   const operationalHoursFromRef = useRef(null);
//   const operationalHoursToRef = useRef(null);
//   const ratePerHourRef = useRef(null);

//   // Refs for violation table
//   const violationRefs = useRef([]);

//   // Refs for assets
//   const assetSubCountRefs = useRef([]);
//   const assetTotalCountRefs = useRef([]);

//   // State refs for data
//   const profileDataRef = useRef(null);
//   const assetsDataRef = useRef(null);
//   const violationDataRef = useRef(null);

//   // ── Fetch ─────────────────────────────────────────────────────────
//   useEffect(() => {
//     if (hasFetchedRef.current) return;
//     hasFetchedRef.current = true;
//     fetchData();
//   }, [year, monthNumber, contract]);

//   const fetchData = async () => {
//     try {
//       const res = await enqueue(() => apiCall('GET', '/boardpack/get-tables-data', { year, contract, month: monthNumber }));
//       if (!res?.success) return;
//       const data = res?.data || [];
//       const find = (key, fb) => data.find(t => t.table_key === key) || fb;

//       const profile = find(cfg.profileKey, cfg.profileFallback);
//       const assets = find(cfg.assetsKey, cfg.assetsFallback);
      
//       setProfileData(profile);
//       setAssetsData(assets);
//       if (cfg.violationKey) {
//         const violation = find(cfg.violationKey, cfg.violationFallback);
//         setViolationData(violation);
//         violationDataRef.current = violation;
//       }
      
//       profileDataRef.current = profile;
//       assetsDataRef.current = assets;
//     } catch (err) {
//       console.error('Fetch error:', err);
//     }
//   };

//   // ── Auto-save ──────────────────────────────────────────────────────
//   const autoSave = () => {
//     if (saveRef.current) clearTimeout(saveRef.current);
//     saveRef.current = setTimeout(saveToAPI, API_CALL_TIME);
//   };

//   const transformAssetsToApiFormat = () => {
//     const currentAssets = assetsDataRef.current?.data?.groups || [];
//     const groups = [];
//     let currentGroup = null;
//     let flatIdx = 0;

//     currentAssets.forEach((group) => {
//       currentGroup = {
//         group_name: group.group_name,
//         group_total_qty: assetTotalCountRefs.current[flatIdx]?.value || group.group_total_qty || '-',
//         items: []
//       };
//       flatIdx++;
      
//       (group.items || []).forEach((item) => {
//         currentGroup.items.push({
//           item_name: item.item_name,
//           qty: assetSubCountRefs.current[flatIdx]?.value || item.qty || '-'
//         });
//         flatIdx++;
//       });
      
//       groups.push(currentGroup);
//     });
    
//     return groups;
//   };

//   const saveToAPI = async () => {
//     try {
//       setIsSaving(true);
      
//       // Get current values from refs
//       const currentTotalBays = totalBaysRef.current?.value || profileDataRef.current?.data?.total_bays?.value || '';
//       const currentContractTerm = contractTermRef.current?.value || profileDataRef.current?.data?.contract_term?.value || '';
//       const currentStartDate = contractStartDateRef.current?.value || profileDataRef.current?.data?.contract_period?.start_date || '';
//       const currentEndDate = contractEndDateRef.current?.value || profileDataRef.current?.data?.contract_period?.end_date || '';
//       const currentOperationalHoursValue = operationalHoursValueRef.current?.value || profileDataRef.current?.data?.operational_hours?.value || '';
//       const currentOperationalHoursFrom = operationalHoursFromRef.current?.value || profileDataRef.current?.data?.operational_hours?.from || '';
//       const currentOperationalHoursTo = operationalHoursToRef.current?.value || profileDataRef.current?.data?.operational_hours?.to || '';
//       const currentRatePerHour = ratePerHourRef.current?.value || profileDataRef.current?.data?.rate_per_hour?.value || '';
      
//       const tables = [
//         { 
//           table_key: profileDataRef.current?.table_key || cfg.profileKey, 
//           title: profileDataRef.current?.title || cfg.profileFallback.title, 
//           data: {
//             total_bays: { label: profileDataRef.current?.data?.total_bays?.label || 'Total Bays', value: currentTotalBays },
//             contract_term: { value: currentContractTerm },
//             contract_period: { start_date: currentStartDate, end_date: currentEndDate },
//             operational_hours: { value: currentOperationalHoursValue, from: currentOperationalHoursFrom, to: currentOperationalHoursTo },
//             rate_per_hour: { value: currentRatePerHour }
//           }
//         },
//         { 
//           table_key: assetsDataRef.current?.table_key || cfg.assetsKey, 
//           title: assetsDataRef.current?.title || cfg.assetsFallback.title, 
//           data: { groups: transformAssetsToApiFormat() }
//         },
//       ];
      
//       // Add violation table if exists
//       if (violationDataRef.current && cfg.violationKey) {
//         const currentViolationRows = (violationDataRef.current?.data?.rows || []).map((row, rowIdx) => ({
//           city_code: violationRefs.current[rowIdx]?.city_code?.value || row.city_code || '',
//           violation_code: violationRefs.current[rowIdx]?.violation_code?.value || row.violation_code || '',
//           violation_name: violationRefs.current[rowIdx]?.violation_name?.value || row.violation_name || '',
//           ticket_charges: violationRefs.current[rowIdx]?.ticket_charges?.value || row.ticket_charges || '',
//           tow_charges: violationRefs.current[rowIdx]?.tow_charges?.value || row.tow_charges || '',
//           clamp_charges: violationRefs.current[rowIdx]?.clamp_charges?.value || row.clamp_charges || '',
//           isLong: row.isLong
//         }));
        
//         tables.push({ 
//           table_key: violationDataRef.current.table_key, 
//           title: violationDataRef.current.title, 
//           data: { rows: currentViolationRows }
//         });
//       }

//       const res = await apiCall('POST', '/boardpack/add-tables-data', {
//         contract, year, month: monthNumber, created_by: 1, tables,
//       });
//       if (!res?.success) throw new Error(res?.message);
//       toast.success('Data saved successfully');
//     } catch (err) {
//       console.error('Save error:', err);
//       toast.error('Failed to save changes');
//     } finally {
//       setIsSaving(false);
//     }
//   };

//   if (!profileData || !assetsData) {
//      return <LoadingComponent/>;;
//   }

//   const pd = profileData.data;
//   const flatAssets = groupsToFlat(assetsData.data.groups);
//   const pageType = cfg.pageType;

//   // ═══════════════════════════════════════════════════════════════════
//   // RENDER
//   // ═══════════════════════════════════════════════════════════════════
//   return (
//     <div className="min-h-screen p-4 md:p-6 lg:p-8 bg-white">

//       {/* ── Header ── */}
//       <div className="flex justify-between items-center mb-3">
//         <div className="ml-2">
//           <img src={AlBahaContract} alt="Al Baha Logo" style={{ height: '50px', objectFit: 'contain' }} />
//         </div>
//         <h1 className="text-xl font-bold flex-1 text-center">{profileData.title}</h1>
//         {/* <div className="w-10 h-10 bg-[#003d7a] flex-shrink-0" /> */}
//       </div>

//       {/* ══════════════════════════════════════
//           ON-STREET PAGE
//       ══════════════════════════════════════ */}
//       {pageType === 'on_street' && (
//         <div className="flex flex-col lg:flex-row gap-0 !border-2 !border-black p-3">

//           {/* ── LEFT ── */}
//           <div className="flex-1 pr-4">

//             {/* Activities icons row */}
//             <div className="mb-2">
//               <p className="text-[16px] font-bold mb-2">Activities:</p>
//               <div className="flex justify-start ml-24">
//                 {['On Street', 'Car Park', 'Enforcement'].map(label => (
//                   <div key={label} className="flex flex-col items-center gap-2">
//                     <div className="flex items-center justify-center text-gray-400 text-[11px]">
//                       {label === 'On Street' && <img src={OnStreet} alt="On Street" style={{ height: '140px', objectFit: 'contain' }} />}
//                       {label === 'Car Park' && <img src={CarPark} alt="Car Park" style={{ height: '140px', objectFit: 'contain' }} />}
//                       {label === 'Enforcement' && <img src={Enforcement} alt="Enforcement" style={{ height: '140px', objectFit: 'contain' }} />}
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </div>

//             {/* Profile info */}
//             <div className="flex flex-col gap-1 mb-4">

//               {/* Total Bays */}
//               <div className="flex items-center gap-2 ml-2">
//                 <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0"></div>
//                 <span className="text-[12px]">
//                   {pd.total_bays?.label}{' '}
//                   <strong>
//                     <input 
//                       type="text" 
//                       defaultValue={pd.total_bays?.value || ''}
//                       ref={totalBaysRef}
//                       onChange={autoSave}
//                       className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-20" 
//                     />
//                   </strong>
//                 </span>
//               </div>

//               {/* Contract term */}
//               <div className="flex items-center gap-2 ml-2">
//                 <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//                 <span className="text-[12px] flex items-center flex-wrap gap-1">
//                   Contract term{' '}
//                   <strong>
//                     <input 
//                       type="text" 
//                       defaultValue={pd.contract_term?.value || ''}
//                       ref={contractTermRef}
//                       onChange={autoSave}
//                       className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-13" 
//                     />
//                   </strong>
//                   ; start date{' '}
//                   <strong>
//                     <input 
//                       type="text" 
//                       defaultValue={pd.contract_period?.start_date || ''}
//                       ref={contractStartDateRef}
//                       onChange={autoSave}
//                       className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-16" 
//                     />
//                   </strong>
//                   {' to '}
//                   <strong>
//                     <input 
//                       type="text" 
//                       defaultValue={pd.contract_period?.end_date || ''}
//                       ref={contractEndDateRef}
//                       onChange={autoSave}
//                       className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-24" 
//                     />
//                   </strong>
//                 </span>
//               </div>

//               {/* Operational Hours */}
//               <div className="flex items-center gap-2 ml-2">
//                 <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//                 <span className="text-[12px] flex items-center flex-wrap gap-1">
//                   Operational Hours{' '}
//                   <strong>
//                     <input 
//                       type="text" 
//                       defaultValue={pd.operational_hours?.value || ''}
//                       ref={operationalHoursValueRef}
//                       onChange={autoSave}
//                       className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-10" 
//                     />
//                   </strong>
//                   {' Per day '}
//                   <strong>
//                     <input 
//                       type="text" 
//                       defaultValue={pd.operational_hours?.from || ''}
//                       ref={operationalHoursFromRef}
//                       onChange={autoSave}
//                       className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-10" 
//                     />
//                   </strong>
//                   {' Hours to '}
//                   <strong>
//                     <input 
//                       type="text" 
//                       defaultValue={pd.operational_hours?.to || ''}
//                       ref={operationalHoursToRef}
//                       onChange={autoSave}
//                       className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-10" 
//                     />
//                   </strong>
//                   {' Hours'}
//                 </span>
//               </div>

//               {/* Rate per Hour */}
//               <div className="flex items-center gap-2 ml-2">
//                 <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//                 <span className="text-[12px] flex items-center gap-1">
//                   Rate per Hour{' '}
//                   <strong>
//                     <input 
//                       type="text" 
//                       defaultValue={pd.rate_per_hour?.value || ''}
//                       ref={ratePerHourRef}
//                       onChange={autoSave}
//                       className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-40" 
//                     />
//                   </strong>
//                 </span>
//               </div>

//               {/* Assets Deployed bullet */}
//               <div className="flex items-center gap-2 ml-2">
//                 <div className="w-3 h-3 rounded-full bg-red-500 flex-shrink-0" />
//                 <span className="text-[12px]">Assets Deployed</span>
//               </div>
//             </div>

//             {/* Violation Summary Table */}
//             {violationData && (
//               <div className="">
//                 <table className="!border-collapse text-[8px]">
//                   <thead>
//                     <tr>
//                       <th colSpan={6} className="!border !border-black px-2 py-1.5 bg-gray-300 text-center font-bold text-[9px]">
//                         {violationData.title}
//                       </th>
//                     </tr>
//                     <tr>
//                       {['City Code', 'Violation Code', 'Violation Name En', 'Ticket Charges', 'Tow Charges', 'Clamp Charges'].map(h => (
//                         <th key={h} className="!border !border-black px-1.5 py-1 font-bold text-center"
//                           style={{ minWidth: h === 'Violation Name En' ? '180px' : '55px' }}>
//                           {h}
//                         </th>
//                       ))}
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {violationData.data.rows.map((row, rIdx) => {
//                       if (!violationRefs.current[rIdx]) violationRefs.current[rIdx] = {};
//                       return (
//                         <tr key={rIdx} className={rIdx % 2 === 0 ? 'bg-white' : ''}>
//                           {[
//                             { key: 'city_code', w: '45px', isLong: false },
//                             { key: 'violation_code', w: '50px', isLong: false },
//                             { key: 'violation_name', w: '180px', isLong: true },
//                             { key: 'ticket_charges', w: '60px', isLong: false },
//                             { key: 'tow_charges', w: '60px', isLong: false },
//                             { key: 'clamp_charges', w: '60px', isLong: false },
//                           ].map(({ key, w, isLong }) => (
//                             <td key={key} className="!border !border-black px-1 py-0.5">
//                               {isLong ? (
//                                 <textarea
//                                   defaultValue={row[key] || ''}
//                                   ref={(el) => { violationRefs.current[rIdx][key] = el; }}
//                                   onChange={autoSave}
//                                   rows={1}
//                                   className="!border-0 bg-transparent outline-none text-[8px] text-left resize-none overflow-hidden"
//                                   style={{
//                                     width: w,
//                                     minWidth: '260px',
//                                     minHeight: '22px',
//                                     lineHeight: '1.1',
//                                     padding: '2px 4px',
//                                   }}
//                                   onInput={e => {
//                                     e.target.style.height = 'auto';
//                                     e.target.style.height = e.target.scrollHeight + 'px';
//                                   }}
//                                 />
//                               ) : (
//                                 <input
//                                   type="text"
//                                   defaultValue={row[key] || ''}
//                                   ref={(el) => { violationRefs.current[rIdx][key] = el; }}
//                                   onChange={autoSave}
//                                   className="!border-0 bg-transparent outline-none text-[8px] text-center"
//                                   style={{ width: w }}
//                                 />
//                               )}
//                             </td>
//                           ))}
//                         </tr>
//                       );
//                     })}
//                   </tbody>
//                 </table>
//               </div>
//             )}
//           </div>

//           {/* ── RIGHT — Assets ── */}
//           <AssetsPanel
//             assetsTable={assetsData}
//             flatAssets={flatAssets}
//             subCountRefs={assetSubCountRefs}
//             totalCountRefs={assetTotalCountRefs}
//             onSubCount={(index, value) => {
//               const updatedFlat = [...flatAssets];
//               updatedFlat[index] = { ...updatedFlat[index], subCount: value };
//               setAssetsData(prev => ({
//                 ...prev,
//                 data: { ...prev.data, groups: flatToGroups(updatedFlat) }
//               }));
//               assetsDataRef.current = {
//                 ...assetsDataRef.current,
//                 data: { ...assetsDataRef.current.data, groups: flatToGroups(updatedFlat) }
//               };
//               autoSave();
//             }}
//             onTotalCount={(index, value) => {
//               const updatedFlat = [...flatAssets];
//               updatedFlat[index] = { ...updatedFlat[index], totalCount: value };
//               setAssetsData(prev => ({
//                 ...prev,
//                 data: { ...prev.data, groups: flatToGroups(updatedFlat) }
//               }));
//               assetsDataRef.current = {
//                 ...assetsDataRef.current,
//                 data: { ...assetsDataRef.current.data, groups: flatToGroups(updatedFlat) }
//               };
//               autoSave();
//             }}
//           />
//         </div>
//       )}

//       {/* ══════════════════════════════════════
//           OFF-STREET PAGE
//       ══════════════════════════════════════ */}
//       {pageType === 'off_street' && (
//         <div className="flex flex-col lg:flex-row gap-0 !border-2 !border-black p-3">

//           {/* ── LEFT ── */}
//           <div className="flex-1 pr-4">

//             {/* Car Park icon + info */}
//             <div className="flex items-start gap-3 mb-4">
//               <div className="flex flex-col items-center rounded bg-gray-50 w-20 flex-shrink-0">
//                 <img src={CarPark} alt="Car Park" style={{ height: '100px', objectFit: 'contain' }} />
//               </div>

//               <div className="flex flex-col gap-1">

//                 {/* Total Bays */}
//                 <div className="flex items-center gap-1">
//                   <div className="w-3 h-3 border border-blue-600 flex-shrink-0" />
//                   <span className="text-[12px]">
//                     {pd.total_bays?.label}{' '}
//                     <strong>
//                       <input 
//                         type="text" 
//                         defaultValue={pd.total_bays?.value || ''}
//                         ref={totalBaysRef}
//                         onChange={autoSave}
//                         className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-24" 
//                       />
//                     </strong>
//                   </span>
//                 </div>

//                 {/* Contract term */}
//                 <div className="flex items-center gap-2 ml-4">
//                   <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//                   <span className="text-[12px] flex items-center flex-wrap gap-1">
//                     Contract term{' '}
//                     <strong>
//                       <input 
//                         type="text" 
//                         defaultValue={pd.contract_term?.value || ''}
//                         ref={contractTermRef}
//                         onChange={autoSave}
//                         className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-13" 
//                       />
//                     </strong>
//                     ; start date{' '}
//                     <strong>
//                       <input 
//                         type="text" 
//                         defaultValue={pd.contract_period?.start_date || ''}
//                         ref={contractStartDateRef}
//                         onChange={autoSave}
//                         className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-16" 
//                       />
//                     </strong>
//                     {' to '}
//                     <strong>
//                       <input 
//                         type="text" 
//                         defaultValue={pd.contract_period?.end_date || ''}
//                         ref={contractEndDateRef}
//                         onChange={autoSave}
//                         className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-24" 
//                       />
//                     </strong>
//                   </span>
//                 </div>

//                 {/* Operational Hours */}
//                 <div className="flex items-center gap-2 ml-4">
//                   <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//                   <span className="text-[12px] flex items-center flex-wrap gap-1">
//                     Operational Hours{' '}
//                     <strong>
//                       <input 
//                         type="text" 
//                         defaultValue={pd.operational_hours?.value || ''}
//                         ref={operationalHoursValueRef}
//                         onChange={autoSave}
//                         className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-10" 
//                       />
//                     </strong>
//                     {' Per day '}
//                     <strong>
//                       <input 
//                         type="text" 
//                         defaultValue={pd.operational_hours?.from || ''}
//                         ref={operationalHoursFromRef}
//                         onChange={autoSave}
//                         className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-10" 
//                       />
//                     </strong>
//                     {' Hours to '}
//                     <strong>
//                       <input 
//                         type="text" 
//                         defaultValue={pd.operational_hours?.to || ''}
//                         ref={operationalHoursToRef}
//                         onChange={autoSave}
//                         className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-8" 
//                       />
//                     </strong>
//                     {' Hours'}
//                   </span>
//                 </div>

//                 {/* Rate per Hour */}
//                 <div className="flex items-center gap-2 ml-4">
//                   <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//                   <span className="text-[12px] flex items-center gap-1">
//                     Rate per Hour{' '}
//                     <strong>
//                       <input 
//                         type="text" 
//                         defaultValue={pd.rate_per_hour?.value || ''}
//                         ref={ratePerHourRef}
//                         onChange={autoSave}
//                         className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-40" 
//                       />
//                     </strong>
//                   </span>
//                 </div>

//                 {/* Assets Deployed bullet */}
//                 <div className="flex items-center gap-2 ml-4">
//                   <div className="w-3 h-3 rounded-full bg-red-500 flex-shrink-0" />
//                   <span className="text-[12px]">Assets Deployed</span>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* ── RIGHT — Assets ── */}
//           <AssetsPanel
//             assetsTable={assetsData}
//             flatAssets={flatAssets}
//             subCountRefs={assetSubCountRefs}
//             totalCountRefs={assetTotalCountRefs}
//             onSubCount={(index, value) => {
//               const updatedFlat = [...flatAssets];
//               updatedFlat[index] = { ...updatedFlat[index], subCount: value };
//               setAssetsData(prev => ({
//                 ...prev,
//                 data: { ...prev.data, groups: flatToGroups(updatedFlat) }
//               }));
//               assetsDataRef.current = {
//                 ...assetsDataRef.current,
//                 data: { ...assetsDataRef.current.data, groups: flatToGroups(updatedFlat) }
//               };
//               autoSave();
//             }}
//             onTotalCount={(index, value) => {
//               const updatedFlat = [...flatAssets];
//               updatedFlat[index] = { ...updatedFlat[index], totalCount: value };
//               setAssetsData(prev => ({
//                 ...prev,
//                 data: { ...prev.data, groups: flatToGroups(updatedFlat) }
//               }));
//               assetsDataRef.current = {
//                 ...assetsDataRef.current,
//                 data: { ...assetsDataRef.current.data, groups: flatToGroups(updatedFlat) }
//               };
//               autoSave();
//             }}
//           />
//         </div>
//       )}

//       {/* {isSaving && (
//         <div className="fixed bottom-4 right-4 bg-blue-600 text-white text-xs px-3 py-1.5 rounded shadow-lg z-50">
//           Saving...
//         </div>
//       )} */}
//     </div>
//   );
// };

// export default AlBahaProfile;








import React, { useState, useRef, useEffect } from 'react';
import { apiCall } from '@/api/apiCall';
import { toast } from 'sonner';
import { useApiQueue } from '@/hooks/useApiQueue';
import AlBahaContract from '@/assets/img/AlBahaContract.png';
import CarPark from '@/assets/img/TaifContract-carPark.png';
import OnStreet from '@/assets/img/TaifContract-onStreet.png';
import Enforcement from '@/assets/img/TaifContract-Enforcement.png';
import { AssetsPanel } from '../../components/shared/AssetsPanel';
import LoadingComponent from '@/components/common/LoadingComponent';
import { API_CALL_TIME } from '@/constants/constant';

// ═══════════════════════════════════════════════════════════════════════
// HELPERS
// ═══════════════════════════════════════════════════════════════════════
const groupsToFlat = (groups = []) => {
  const result = [];
  groups.forEach(g => {
    result.push({ name: g.group_name || '', isCategory: true, subCount: '', totalCount: String(g.group_total_qty ?? '-') });
    (g.items || []).forEach(item => {
      result.push({ name: item.item_name || '', isCategory: false, subCount: String(item.qty ?? '-'), totalCount: '' });
    });
  });
  return result;
};

const flatToGroups = (flat) => {
  const groups = [];
  let cur = null;
  flat.forEach(a => {
    if (a.isCategory) {
      if (cur) groups.push(cur);
      cur = { group_name: a.name, group_total_qty: a.totalCount || '', items: [] };
    } else if (cur) {
      cur.items.push({ item_name: a.name, qty: a.subCount || '' });
    }
  });
  if (cur) groups.push(cur);
  return groups;
};

// ═══════════════════════════════════════════════════════════════════════
// ASSET GROUPS HELPER
// ═══════════════════════════════════════════════════════════════════════
function makeAssetGroups(o = {}) {
  return [
    { group_name: 'Ticket Dispenser',    group_total_qty: o.ticketDispenser ?? '-', items: [{ item_name: 'DIP G100', qty: o.dipG100 ?? '-' }, { item_name: 'G100 64 Bit', qty: o.g10064 ?? '-' }, { item_name: 'G100 32 Bit', qty: o.g10032 ?? '-' }] },
    { group_name: 'Ticket Verifier',     group_total_qty: o.ticketVerifier  ?? '-', items: [{ item_name: 'EV DIP G100', qty: o.evDipG100 ?? '-' }, { item_name: 'EV G100 64 Bit', qty: o.evG10064 ?? '-' }, { item_name: 'EV G100 32 Bit', qty: o.evG10032 ?? '-' }] },
    { group_name: "APM's",               group_total_qty: o.apms            ?? '-', items: [{ item_name: 'APM ETS-70', qty: o.apmEts70 ?? '-' }, { item_name: 'APM ETS-100', qty: o.apmEts100 ?? '-' }] },
    { group_name: 'PIN Pad',             group_total_qty: o.pinPad          ?? '-', items: [{ item_name: 'IUP250', qty: o.iup250 ?? '-' }] },
    { group_name: 'Card Reader',         group_total_qty: o.cardReader      ?? '-', items: [{ item_name: 'IUR250', qty: o.iur250 ?? '-' }] },
    { group_name: 'B-Contactless',       group_total_qty: o.bContactless    ?? '-', items: [{ item_name: 'IUC150', qty: o.bContactlessItem ?? '-' }] },
    { group_name: 'RFID Reader',         group_total_qty: o.rfidReader      ?? '-', items: [] },
    { group_name: 'IP Barrier',          group_total_qty: o.ipBarrier       ?? '-', items: [] },
    { group_name: 'ANPR CAMERA',         group_total_qty: o.anprCamera      ?? '-', items: [{ item_name: 'ARH', qty: o.arh ?? '-' }, { item_name: 'Luminera', qty: o.luminera ?? '-' }] },
    { group_name: 'Sliding Gate',        group_total_qty: o.slidingGate     ?? '-', items: [{ item_name: 'RIGHT', qty: o.right ?? '-' }, { item_name: 'LEFT', qty: o.left ?? '-' }] },
    { group_name: "PND's",               group_total_qty: o.pnds            ?? '-', items: [{ item_name: 'TPAL- BNA Large', qty: o.tpalBna ?? '-' }, { item_name: 'T-PAL TX', qty: o.tpalTx ?? '-' }, { item_name: 'T-PAL V2', qty: o.tpalV2 ?? '-' }] },
    { group_name: 'Pound Cahier Device', group_total_qty: o.poundCahier     ?? '-', items: [{ item_name: 'CN-50', qty: o.cn50 ?? '-' }] },
    { group_name: 'Driver Device',       group_total_qty: o.driverDevice    ?? '-', items: [{ item_name: 'CN-51', qty: o.cn51 ?? '-' }] },
    { group_name: 'Enf Device',          group_total_qty: o.enfDevice       ?? '-', items: [{ item_name: 'Oukitel WP2', qty: o.oukitel ?? '-' }, { item_name: 'Doogee V10', qty: o.doogee ?? '-' }] },
    { group_name: 'Validation',          group_total_qty: o.validation      ?? '-', items: [{ item_name: 'Lenova Tablet', qty: o.lenovaTablet ?? '-' }] },
    { group_name: 'Printer',             group_total_qty: o.printer         ?? '-', items: [{ item_name: 'PR-3', qty: o.pr3 ?? '-' }, { item_name: 'SEWOO', qty: o.sewoo ?? '-' }, { item_name: 'BIXOLON', qty: o.bixolon ?? '-' }] },
    { group_name: 'Tow Truck',           group_total_qty: o.towTruck        ?? '-', items: [] },
    { group_name: 'Clamp Vehicle',       group_total_qty: o.clampVehicle    ?? '-', items: [] },
    { group_name: 'Support Vehicle',     group_total_qty: o.supportVehicle  ?? '-', items: [] },
  ];
}

// ═══════════════════════════════════════════════════════════════════════
// CONFIG
// ═══════════════════════════════════════════════════════════════════════
const ALBAHA_PROFILE_CONFIG = {

  // ── Al Baha On-Street Profile ───────────────────────────────────────
  albaha_on_street_profile: {
    profileKey:       'albaha_on_street_profile',
    violationKey:     'albaha_on_street_violations',
    assetsKey:        'albaha_on_street_assets',
    pageType:         'on_street',

    profileFallback: {
      table_key: 'albaha_on_street_profile',
      title: 'Al Baha On Street - Profile',
      data: {
        total_bays:        { label: 'Total On-Street Parking Bays', value: '1,721' },
        contract_term:     { value: '23 years' },
        contract_period:   { start_date: '12.07.2021', end_date: '12.10.2045' },
        operational_hours: { value: '15 Hours', from: '08:00', to: '23:00' },
        rate_per_hour:     { value: 'SAR 03 + VAT 15%' },
      },
    },

    violationFallback: {
      table_key: 'albaha_on_street_violations',
      title: 'Al Baha On Street Violation Summary (Excluding Vat)',
      data: {
        rows: [
          { city_code: 'BAHA', violation_code: '1',  violation_name: 'THE USE OF PARKING SPACE WITHOUT PAYING THE PARKING FEE',    isLong:true,                 ticket_charges: '200',           tow_charges: '250',      clamp_charges: '0' },
          { city_code: 'BAHA', violation_code: '2',  violation_name: 'THE EXPIRY OF THE PAID PARKING PERIOD WITHOUT VACATING THE PARKING SPACE',      ticket_charges: '100',           tow_charges: '-',        clamp_charges: '0' },
          { city_code: 'BAHA', violation_code: '3',  violation_name: 'EXCEEDING THE MAXIMUM TIME ALLOWED FOR THE PARKING SPACE',                      ticket_charges: '100',           tow_charges: '250',      clamp_charges: '0' },
          { city_code: 'BAHA', violation_code: '4',  violation_name: 'PARKING CONTRARILY WITHIN THE PAID PARKING SPACE',                              ticket_charges: '300',           tow_charges: '250',      clamp_charges: '0' },
          { city_code: 'BAHA', violation_code: '5',  violation_name: 'PARKING IN A RESERVED PARKING SPACE',                                           ticket_charges: '300',           tow_charges: '250',      clamp_charges: '0' },
          { city_code: 'BAHA', violation_code: '6',  violation_name: 'PARKING IN A RESTRICTED SPACE',                                                 ticket_charges: '300',           tow_charges: '250',      clamp_charges: '0' },
          { city_code: 'BAHA', violation_code: '7',  violation_name: 'PLACING BARRIERS, OBSTRUCTIONS, FORGERY, OR CLOSING A PARKING SPACE WITHOUT A PERMIT', ticket_charges: '400',  tow_charges: '250',      clamp_charges: '0' },
          { city_code: 'BAHA', violation_code: '8',  violation_name: 'PARKING IN THE EMERGENCY DESIGNATED AREAS',                                     ticket_charges: '900',           tow_charges: '250',      clamp_charges: '0' },
          { city_code: 'BAHA', violation_code: '9',  violation_name: 'PARKING AT THE ENTRANCES AND EXITS OF BUILDINGS',                               ticket_charges: '500',           tow_charges: '250',      clamp_charges: '0' },
          { city_code: 'BAHA', violation_code: '10', violation_name: 'TOW CHARGES (Light & Heavy Vehicle)',                                            ticket_charges: '0',             tow_charges: '250/1250', clamp_charges: '0' },
          { city_code: 'BAHA', violation_code: '11', violation_name: 'STORAGE CHARGES (Light & Heavy Vehicle)',                                        ticket_charges: '20/50 per day', tow_charges: '0',        clamp_charges: '0' },
        ],
      },
    },

    assetsFallback: {
      table_key: 'albaha_on_street_assets',
      title: 'Al Baha On-street',
      data: {
        groups: makeAssetGroups({
          ticketDispenser: '-', ticketVerifier: '1', evG10064: '1',
          apms: '-', pinPad: '-', cardReader: '-', iur250: '-',
          bContactless: '-', rfidReader: '4', ipBarrier: '-',
          anprCamera: '-', slidingGate: '3', right: '2', left: '1',
          pnds: '95', tpalTx: '63', tpalV2: '32',
          poundCahier: '-', driverDevice: '-',
          enfDevice: '19', oukitel: '-', doogee: '19',
          validation: '-', printer: '25', pr3: '-', sewoo: '-', bixolon: '25',
          towTruck: '6', clampVehicle: '1', supportVehicle: '1',
        }),
      },
    },
  },

  // ── Al Baha Off-Street Profile ──────────────────────────────────────
  albaha_off_street_profile: {
    profileKey:  'albaha_off_street_profile',
    assetsKey:   'albaha_off_street_assets',
    pageType:    'off_street',

    profileFallback: {
      table_key: 'albaha_off_street_profile',
      title: 'Al Baha Off-Street Profile',
      data: {
        total_bays:        { label: 'Total Off Street Car Park Bays', value: '........' },
        contract_term:     { value: '23 years' },
        contract_period:   { start_date: '12.07.2021', end_date: '12.10.2045' },
        operational_hours: { value: '........', from: '.......', to: '....... ' },
        rate_per_hour:     { value: '........' },
      },
    },

    assetsFallback: {
      table_key: 'albaha_off_street_assets',
      title: 'Al Baha Off-street',
      data: {
        groups: makeAssetGroups({
          ticketDispenser: '-', ticketVerifier: '-',
          apms: '-', pinPad: '-', cardReader: '-',
          bContactless: '-', rfidReader: '-', ipBarrier: '-',
          anprCamera: '-', slidingGate: '-', pnds: '-',
          poundCahier: '-', driverDevice: '-', enfDevice: '-',
          validation: '-', printer: '-', towTruck: '-',
          clampVehicle: '-', supportVehicle: '-',
        }),
      },
    },
  },
};

// ═══════════════════════════════════════════════════════════════════════
// MAIN COMPONENT
// ═══════════════════════════════════════════════════════════════════════
const AlBahaProfile = ({ page, year = '', month = '', monthNumber = '', contract = '' }) => {
  const cfg = ALBAHA_PROFILE_CONFIG[page?.type];
  if (!cfg) return null;

  const hasFetchedRef = useRef(false);
  const saveRef = useRef(null);
  const [isSaving, setIsSaving] = useState(false);
  
  // 🔥 State for second API (parking bays)
  const [parkingBaysData, setParkingBaysData] = useState(null);
  
  const [profileData, setProfileData] = useState(null);
  const [assetsData, setAssetsData] = useState(null);
  const [violationData, setViolationData] = useState(null);
  
  const { enqueue } = useApiQueue();

  // 🔥 Effective total bays - second API se aayega
  const effectiveTotalBays = parkingBaysData?.total_bays ?? profileData?.data?.total_bays?.value ?? '0';

  // Refs for profile inputs
  // 🔥 REMOVED: totalBaysRef (ab readonly hai)
  const contractTermRef = useRef(null);
  const contractStartDateRef = useRef(null);
  const contractEndDateRef = useRef(null);
  const operationalHoursValueRef = useRef(null);
  const operationalHoursFromRef = useRef(null);
  const operationalHoursToRef = useRef(null);
  const ratePerHourRef = useRef(null);

  // Refs for violation table
  const violationRefs = useRef([]);

  // Refs for assets
  const assetSubCountRefs = useRef([]);
  const assetTotalCountRefs = useRef([]);

  // State refs for data
  const profileDataRef = useRef(null);
  const assetsDataRef = useRef(null);
  const violationDataRef = useRef(null);

  // ── Fetch BOTH APIs ─────────────────────────────────────────────────────────────
  useEffect(() => {
    if (hasFetchedRef.current) return;
    hasFetchedRef.current = true;
    fetchAllData();
  }, [year, month, monthNumber, contract]);

  const fetchAllData = async () => {
    try {
      // 🔥 Second API params based on page type
      const isOnStreet = cfg.pageType === 'on_street';
      const secondApiParams = isOnStreet ? {
        contract: "0030021",
        year: year,
        month: month,
        device_onstreet: "BHA",
        type: "on_street"
      } : {
        contract: "0030022",
        year: year,
        month: month,
        type: "off_street"
      };
      
      const [firstApiResponse, secondApiResponse] = await Promise.all([
        enqueue(() => apiCall('GET', '/boardpack/get-tables-data', { year, contract, month: monthNumber })),
        enqueue(() => apiCall('GET', '/boardpack/parking/bays', secondApiParams))
      ]);

      // Process first API response
      if (firstApiResponse?.success) {
        const data = firstApiResponse?.data || [];
        const find = (key, fb) => data.find(t => t.table_key === key) || fb;

        const profile = find(cfg.profileKey, cfg.profileFallback);
        const assets = find(cfg.assetsKey, cfg.assetsFallback);
        
        setProfileData(profile);
        setAssetsData(assets);
        if (cfg.violationKey) {
          const violation = find(cfg.violationKey, cfg.violationFallback);
          setViolationData(violation);
          violationDataRef.current = violation;
        }
        
        profileDataRef.current = profile;
        assetsDataRef.current = assets;
      }

      // 🔥 Process second API response for parking bays
      if (secondApiResponse?.success && secondApiResponse?.data) {
        setParkingBaysData(secondApiResponse.data);
      } else {
        console.warn("Second API failed:", secondApiResponse?.message);
        setParkingBaysData(null);
      }
      
    } catch (err) {
      console.error('Fetch error:', err);
    }
  };

  // ── Auto-save ──────────────────────────────────────────────────────
  const autoSave = () => {
    if (saveRef.current) clearTimeout(saveRef.current);
    saveRef.current = setTimeout(saveToAPI, API_CALL_TIME);
  };

  const transformAssetsToApiFormat = () => {
    const currentAssets = assetsDataRef.current?.data?.groups || [];
    const groups = [];
    let currentGroup = null;
    let flatIdx = 0;

    currentAssets.forEach((group) => {
      currentGroup = {
        group_name: group.group_name,
        group_total_qty: assetTotalCountRefs.current[flatIdx]?.value || group.group_total_qty || '-',
        items: []
      };
      flatIdx++;
      
      (group.items || []).forEach((item) => {
        currentGroup.items.push({
          item_name: item.item_name,
          qty: assetSubCountRefs.current[flatIdx]?.value || item.qty || '-'
        });
        flatIdx++;
      });
      
      groups.push(currentGroup);
    });
    
    return groups;
  };

  const saveToAPI = async () => {
    try {
      setIsSaving(true);
      
      // 🔥 totalBays - ab read-only value use karo
      const currentTotalBays = effectiveTotalBays;
      const currentContractTerm = contractTermRef.current?.value || profileDataRef.current?.data?.contract_term?.value || '';
      const currentStartDate = contractStartDateRef.current?.value || profileDataRef.current?.data?.contract_period?.start_date || '';
      const currentEndDate = contractEndDateRef.current?.value || profileDataRef.current?.data?.contract_period?.end_date || '';
      const currentOperationalHoursValue = operationalHoursValueRef.current?.value || profileDataRef.current?.data?.operational_hours?.value || '';
      const currentOperationalHoursFrom = operationalHoursFromRef.current?.value || profileDataRef.current?.data?.operational_hours?.from || '';
      const currentOperationalHoursTo = operationalHoursToRef.current?.value || profileDataRef.current?.data?.operational_hours?.to || '';
      const currentRatePerHour = ratePerHourRef.current?.value || profileDataRef.current?.data?.rate_per_hour?.value || '';
      
      const tables = [
        { 
          table_key: profileDataRef.current?.table_key || cfg.profileKey, 
          title: profileDataRef.current?.title || cfg.profileFallback.title, 
          data: {
            total_bays: { label: profileDataRef.current?.data?.total_bays?.label || 'Total Bays', value: currentTotalBays },
            contract_term: { value: currentContractTerm },
            contract_period: { start_date: currentStartDate, end_date: currentEndDate },
            operational_hours: { value: currentOperationalHoursValue, from: currentOperationalHoursFrom, to: currentOperationalHoursTo },
            rate_per_hour: { value: currentRatePerHour }
          }
        },
        { 
          table_key: assetsDataRef.current?.table_key || cfg.assetsKey, 
          title: assetsDataRef.current?.title || cfg.assetsFallback.title, 
          data: { groups: transformAssetsToApiFormat() }
        },
      ];
      
      // Add violation table if exists
      if (violationDataRef.current && cfg.violationKey) {
        const currentViolationRows = (violationDataRef.current?.data?.rows || []).map((row, rowIdx) => ({
          city_code: violationRefs.current[rowIdx]?.city_code?.value || row.city_code || '',
          violation_code: violationRefs.current[rowIdx]?.violation_code?.value || row.violation_code || '',
          violation_name: violationRefs.current[rowIdx]?.violation_name?.value || row.violation_name || '',
          ticket_charges: violationRefs.current[rowIdx]?.ticket_charges?.value || row.ticket_charges || '',
          tow_charges: violationRefs.current[rowIdx]?.tow_charges?.value || row.tow_charges || '',
          clamp_charges: violationRefs.current[rowIdx]?.clamp_charges?.value || row.clamp_charges || '',
          isLong: row.isLong
        }));
        
        tables.push({ 
          table_key: violationDataRef.current.table_key, 
          title: violationDataRef.current.title, 
          data: { rows: currentViolationRows }
        });
      }

      const res = await apiCall('POST', '/boardpack/add-tables-data', {
        contract, year, month: monthNumber, created_by: 1, tables,
      });
      if (!res?.success) throw new Error(res?.message);
      // toast.success('Data saved successfully');
    } catch (err) {
      console.error('Save error:', err);
      toast.error('Failed to save changes');
    } finally {
      setIsSaving(false);
    }
  };

  if (!profileData || !assetsData) {
     return <LoadingComponent/>;
  }

  const pd = profileData.data;
  const flatAssets = groupsToFlat(assetsData.data.groups);
  const pageType = cfg.pageType;

  // ═══════════════════════════════════════════════════════════════════
  // RENDER
  // ═══════════════════════════════════════════════════════════════════
  return (
    <div className="min-h-screen p-8 bg-white">

      {/* ── Header ── */}
      <div className="flex justify-between items-center mb-3">
        <div className="ml-2">
          <img src={AlBahaContract} alt="Al Baha Logo" style={{ height: '50px', objectFit: 'contain' }} />
        </div>
        <h1 className="text-xl font-bold flex-1 text-center">{profileData.title}</h1>
      </div>

      {/* ══════════════════════════════════════
          ON-STREET PAGE
      ══════════════════════════════════════ */}
      {pageType === 'on_street' && (
        <div className="flex flex-row gap-0 !border-2 !border-black p-3">

          {/* ── LEFT ── */}
          <div className="flex-1 pr-4">

            {/* Activities icons row */}
            <div className="mb-2">
              <p className="text-[16px] font-bold mb-2">Activities:</p>
              <div className="flex justify-start ml-24">
                {['On Street', 'Car Park', 'Enforcement'].map(label => (
                  <div key={label} className="flex flex-col items-center gap-2">
                    <div className="flex items-center justify-center text-gray-400 text-[11px]">
                      {label === 'On Street' && <img src={OnStreet} alt="On Street" style={{ height: '140px', objectFit: 'contain' }} />}
                      {label === 'Car Park' && <img src={CarPark} alt="Car Park" style={{ height: '140px', objectFit: 'contain' }} />}
                      {label === 'Enforcement' && <img src={Enforcement} alt="Enforcement" style={{ height: '140px', objectFit: 'contain' }} />}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Profile info */}
            <div className="flex flex-col gap-1 mb-4">

              {/* 🔥 READ-ONLY Total Bays */}
              <div className="flex items-center gap-2 ml-2">
                <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0"></div>
                <span className="text-[12px]">
                  {pd.total_bays?.label}{' '}
                  <strong>
                    <input 
                      type="text" 
                      value={effectiveTotalBays}
                      readOnly 
                      disabled
                      className="font-bold outline-none bg-transparent !border-0 text-[12px] w-20 cursor-default" 
                    />
                  </strong>
                </span>
              </div>

              {/* Contract term - Editable */}
              <div className="flex items-center gap-2 ml-2">
                <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
                <span className="text-[12px] flex items-center flex-wrap gap-1">
                  Contract term{' '}
                  <strong>
                    <input 
                      type="text" 
                      defaultValue={pd.contract_term?.value || ''}
                      ref={contractTermRef}
                      onChange={autoSave}
                      className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-13" 
                    />
                  </strong>
                  ; start date{' '}
                  <strong>
                    <input 
                      type="text" 
                      defaultValue={pd.contract_period?.start_date || ''}
                      ref={contractStartDateRef}
                      onChange={autoSave}
                      className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-16" 
                    />
                  </strong>
                  {' to '}
                  <strong>
                    <input 
                      type="text" 
                      defaultValue={pd.contract_period?.end_date || ''}
                      ref={contractEndDateRef}
                      onChange={autoSave}
                      className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-24" 
                    />
                  </strong>
                </span>
              </div>

              {/* Operational Hours - Editable */}
              <div className="flex items-center gap-2 ml-2">
                <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
                <span className="text-[12px] flex items-center flex-wrap gap-1">
                  Operational Hours{' '}
                  <strong>
                    <input 
                      type="text" 
                      defaultValue={pd.operational_hours?.value || ''}
                      ref={operationalHoursValueRef}
                      onChange={autoSave}
                      className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-10" 
                    />
                  </strong>
                  {' Per day '}
                  <strong>
                    <input 
                      type="text" 
                      defaultValue={pd.operational_hours?.from || ''}
                      ref={operationalHoursFromRef}
                      onChange={autoSave}
                      className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-10" 
                    />
                  </strong>
                  {' Hours to '}
                  <strong>
                    <input 
                      type="text" 
                      defaultValue={pd.operational_hours?.to || ''}
                      ref={operationalHoursToRef}
                      onChange={autoSave}
                      className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-10" 
                    />
                  </strong>
                  {' Hours'}
                </span>
              </div>

              {/* Rate per Hour - Editable */}
              <div className="flex items-center gap-2 ml-2">
                <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
                <span className="text-[12px] flex items-center gap-1">
                  Rate per Hour{' '}
                  <strong>
                    <input 
                      type="text" 
                      defaultValue={pd.rate_per_hour?.value || ''}
                      ref={ratePerHourRef}
                      onChange={autoSave}
                      className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-40" 
                    />
                  </strong>
                </span>
              </div>

              {/* Assets Deployed bullet */}
              <div className="flex items-center gap-2 ml-2">
                <div className="w-3 h-3 rounded-full bg-red-500 flex-shrink-0" />
                <span className="text-[12px]">Assets Deployed</span>
              </div>
            </div>

            {/* Violation Summary Table - Editable */}
            {violationData && (
              <div className="">
                <table className="!border-collapse text-[8px]">
                  <thead>
                    <tr>
                      <th colSpan={6} className="!border !border-black px-2 py-1.5 bg-gray-300 text-center font-bold text-[9px]">
                        {violationData.title}
                      </th>
                    </tr>
                    <tr>
                      {['City Code', 'Violation Code', 'Violation Name En', 'Ticket Charges', 'Tow Charges', 'Clamp Charges'].map(h => (
                        <th key={h} className="!border !border-black px-1.5 py-1 font-bold text-center"
                          style={{ minWidth: h === 'Violation Name En' ? '180px' : '55px' }}>
                          {h}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {violationData.data.rows.map((row, rIdx) => {
                      if (!violationRefs.current[rIdx]) violationRefs.current[rIdx] = {};
                      return (
                        <tr key={rIdx} className={rIdx % 2 === 0 ? 'bg-white' : ''}>
                          {[
                            { key: 'city_code', w: '45px', isLong: false },
                            { key: 'violation_code', w: '50px', isLong: false },
                            { key: 'violation_name', w: '180px', isLong: true },
                            { key: 'ticket_charges', w: '60px', isLong: false },
                            { key: 'tow_charges', w: '60px', isLong: false },
                            { key: 'clamp_charges', w: '60px', isLong: false },
                          ].map(({ key, w, isLong }) => (
                            <td key={key} className="!border !border-black px-1 py-0.5">
                              {isLong ? (
                                <textarea
                                  defaultValue={row[key] || ''}
                                  ref={(el) => { violationRefs.current[rIdx][key] = el; }}
                                  onChange={autoSave}
                                  rows={1}
                                  className="!border-0 bg-transparent outline-none text-[8px] text-left resize-none overflow-hidden"
                                  style={{
                                    minWidth: '260px',
                                    minHeight: '22px',
                                    lineHeight: '1.1',
                                    padding: '2px 4px',
                                  }}
                                  onInput={e => {
                                    e.target.style.height = 'auto';
                                    e.target.style.height = e.target.scrollHeight + 'px';
                                  }}
                                />
                              ) : (
                                <input
                                  type="text"
                                  defaultValue={row[key] || ''}
                                  ref={(el) => { violationRefs.current[rIdx][key] = el; }}
                                  onChange={autoSave}
                                  className="!border-0 bg-transparent outline-none text-[8px] text-center"
                                  style={{ width: w }}
                                />
                              )}
                            </td>
                          ))}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}
          </div>

          {/* ── RIGHT — Assets ── */}
          <AssetsPanel
            assetsTable={assetsData}
            flatAssets={flatAssets}
            subCountRefs={assetSubCountRefs}
            totalCountRefs={assetTotalCountRefs}
            onSubCount={(index, value) => {
              const updatedFlat = [...flatAssets];
              updatedFlat[index] = { ...updatedFlat[index], subCount: value };
              setAssetsData(prev => ({
                ...prev,
                data: { ...prev.data, groups: flatToGroups(updatedFlat) }
              }));
              assetsDataRef.current = {
                ...assetsDataRef.current,
                data: { ...assetsDataRef.current.data, groups: flatToGroups(updatedFlat) }
              };
              autoSave();
            }}
            onTotalCount={(index, value) => {
              const updatedFlat = [...flatAssets];
              updatedFlat[index] = { ...updatedFlat[index], totalCount: value };
              setAssetsData(prev => ({
                ...prev,
                data: { ...prev.data, groups: flatToGroups(updatedFlat) }
              }));
              assetsDataRef.current = {
                ...assetsDataRef.current,
                data: { ...assetsDataRef.current.data, groups: flatToGroups(updatedFlat) }
              };
              autoSave();
            }}
          />
        </div>
      )}

      {/* ══════════════════════════════════════
          OFF-STREET PAGE
      ══════════════════════════════════════ */}
      {pageType === 'off_street' && (
        <div className="flex flex-row gap-0 !border-2 !border-black p-3">

          {/* ── LEFT ── */}
          <div className="flex-1 pr-4">

            {/* Car Park icon + info */}
            <div className="flex items-start gap-3 mb-4">
              <div className="flex flex-col items-center rounded bg-gray-50 w-20 flex-shrink-0">
                <img src={CarPark} alt="Car Park" style={{ height: '100px', objectFit: 'contain' }} />
              </div>

              <div className="flex flex-col gap-1">

                {/* 🔥 READ-ONLY Total Bays */}
                <div className="flex items-center gap-1">
                  <div className="w-3 h-3 border border-blue-600 flex-shrink-0" />
                  <span className="text-[12px]">
                    {pd.total_bays?.label}{' '}
                    <strong>
                      <input 
                        type="text" 
                        value={effectiveTotalBays}
                        readOnly 
                        disabled
                        className="font-bold outline-none bg-transparent !border-0 text-[12px] w-24 cursor-default" 
                      />
                    </strong>
                  </span>
                </div>

                {/* Contract term - Editable */}
                <div className="flex items-center gap-2 ml-4">
                  <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
                  <span className="text-[12px] flex items-center flex-wrap gap-1">
                    Contract term{' '}
                    <strong>
                      <input 
                        type="text" 
                        defaultValue={pd.contract_term?.value || ''}
                        ref={contractTermRef}
                        onChange={autoSave}
                        className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-13" 
                      />
                    </strong>
                    ; start date{' '}
                    <strong>
                      <input 
                        type="text" 
                        defaultValue={pd.contract_period?.start_date || ''}
                        ref={contractStartDateRef}
                        onChange={autoSave}
                        className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-16" 
                      />
                    </strong>
                    {' to '}
                    <strong>
                      <input 
                        type="text" 
                        defaultValue={pd.contract_period?.end_date || ''}
                        ref={contractEndDateRef}
                        onChange={autoSave}
                        className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-24" 
                      />
                    </strong>
                  </span>
                </div>

                {/* Operational Hours - Editable */}
                <div className="flex items-center gap-2 ml-4">
                  <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
                  <span className="text-[12px] flex items-center flex-wrap gap-1">
                    Operational Hours{' '}
                    <strong>
                      <input 
                        type="text" 
                        defaultValue={pd.operational_hours?.value || ''}
                        ref={operationalHoursValueRef}
                        onChange={autoSave}
                        className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-10" 
                      />
                    </strong>
                    {' Per day '}
                    <strong>
                      <input 
                        type="text" 
                        defaultValue={pd.operational_hours?.from || ''}
                        ref={operationalHoursFromRef}
                        onChange={autoSave}
                        className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-10" 
                      />
                    </strong>
                    {' Hours to '}
                    <strong>
                      <input 
                        type="text" 
                        defaultValue={pd.operational_hours?.to || ''}
                        ref={operationalHoursToRef}
                        onChange={autoSave}
                        className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-8" 
                      />
                    </strong>
                    {' Hours'}
                  </span>
                </div>

                {/* Rate per Hour - Editable */}
                <div className="flex items-center gap-2 ml-4">
                  <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
                  <span className="text-[12px] flex items-center gap-1">
                    Rate per Hour{' '}
                    <strong>
                      <input 
                        type="text" 
                        defaultValue={pd.rate_per_hour?.value || ''}
                        ref={ratePerHourRef}
                        onChange={autoSave}
                        className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-40" 
                      />
                    </strong>
                  </span>
                </div>

                {/* Assets Deployed bullet */}
                <div className="flex items-center gap-2 ml-4">
                  <div className="w-3 h-3 rounded-full bg-red-500 flex-shrink-0" />
                  <span className="text-[12px]">Assets Deployed</span>
                </div>
              </div>
            </div>
          </div>

          {/* ── RIGHT — Assets ── */}
          <AssetsPanel
            assetsTable={assetsData}
            flatAssets={flatAssets}
            subCountRefs={assetSubCountRefs}
            totalCountRefs={assetTotalCountRefs}
            onSubCount={(index, value) => {
              const updatedFlat = [...flatAssets];
              updatedFlat[index] = { ...updatedFlat[index], subCount: value };
              setAssetsData(prev => ({
                ...prev,
                data: { ...prev.data, groups: flatToGroups(updatedFlat) }
              }));
              assetsDataRef.current = {
                ...assetsDataRef.current,
                data: { ...assetsDataRef.current.data, groups: flatToGroups(updatedFlat) }
              };
              autoSave();
            }}
            onTotalCount={(index, value) => {
              const updatedFlat = [...flatAssets];
              updatedFlat[index] = { ...updatedFlat[index], totalCount: value };
              setAssetsData(prev => ({
                ...prev,
                data: { ...prev.data, groups: flatToGroups(updatedFlat) }
              }));
              assetsDataRef.current = {
                ...assetsDataRef.current,
                data: { ...assetsDataRef.current.data, groups: flatToGroups(updatedFlat) }
              };
              autoSave();
            }}
          />
        </div>
      )}
    </div>
  );
};

export default AlBahaProfile;
